export const MAIN_DESCRIPTION = 'Please use desktop version instead'
